/* istanbul ignore file */
import { array as codecArray, boolean as codecBoolean, number as codecNumber, } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { User } from './User';
import { Work } from './Work';
const PlagiarismCaseParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['users', /* #__PURE__ */ codecArray(User)],
    ['matchMax', codecNumber, 'match_max'],
    ['matchAvg', codecNumber, 'match_avg'],
    [
        'submissions',
        /* #__PURE__ */ parsers.maybeNull(/* #__PURE__ */ codecArray(Work)),
    ],
    ['canSeeDetails', codecBoolean, 'can_see_details'],
    ['assignmentIds', /* #__PURE__ */ codecArray(codecNumber), 'assignment_ids'],
]));
export class PlagiarismCase extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PlagiarismCaseParser.decode(input).map(res => new PlagiarismCase(res));
    }
    static unsafeDecode(input) {
        return PlagiarismCase.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PlagiarismCaseParser.encode(data);
    }
    static schema() {
        return PlagiarismCaseParser.schema();
    }
}
